var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Trans } from 'react-i18next';
import { translate } from '../../../strings/i18n';
import { VerifyLinkTextWrapper, VerifyUserButton } from './subcomponents';
import { TextWrapper } from '../subcomponents';
import StatusMessage from '../StatusMessageBox';
import { ConfigContext } from '../../../context';
var VerifyMessageBox = function () {
    var authenticationRedirect = useContext(ConfigContext).authenticationRedirect;
    var verifyUserLinkText = translate('verifyMessageBox.body');
    var verifyUserLink = (_jsx(VerifyUserButton, __assign({ buttonType: "text", "data-type": "please verify your account", "data-object": "link", "data-analytics": "clicktrackingevent", onClick: function () { return authenticationRedirect(); } }, { children: verifyUserLinkText })));
    return (_jsx(StatusMessage, { messageTitle: translate('verifyMessageBox.title'), messageDescription: _jsx(TextWrapper, { children: _jsx(VerifyLinkTextWrapper, { children: _jsx(Trans, __assign({ i18nKey: "verifyMessageBox", value: verifyUserLink, components: { verifyUserLink: verifyUserLink } }, { children: translate('verifyMessageBox.body', {
                        verifyUserLinkText: verifyUserLinkText
                    }) })) }) }) }));
};
export default VerifyMessageBox;
